import { client } from "../../../api/client";

export const fetchActiveItemLookupVersionByItemLookupId = async (itemLookupId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            // Load local data and filter by ids
            const items = require("./_local/_itemLookupData.json").itemLookupItems || [];
            const match = items.find(x => String(x.id) === String(itemLookupId));
            const versions = Array.isArray(match?.itemLookupVersions) ? match.itemLookupVersions : [];
            return versions[0] ?? null;
        } catch (error) {
            console.error("Error fetching active item lookup version by itemLookupId (local):", error);
            return null;
        }
    } else {
        try {
            const response = await client.get(
                process.env.REACT_APP_GATEWAY_URI,
                "iquoteapi/itemlookupversion/getActiveItemLookupVersionByItemLookupId/" + itemLookupId
            );            
            return response.data ?? null;
        } catch (error) {
            console.error("Error fetching active item lookup version by itemLookupId:", error);
            return null;
        }
    }
};

export const createItemLookupVersions = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.post(process.env.REACT_APP_GATEWAY_URI,'iquoteapi/itemlookupversion/bulk', body);
    } catch (error) {
        console.error("Error creating item lookup versions:", error);
        return [];
    }
  } else {
    let bodyWithNewIds = {}
    bodyWithNewIds.savedItems = body.map(item => ({ ...item, id: Math.floor(Math.random() * 100000) }));
    return { "data":  bodyWithNewIds };
  }
};

export const updateItemLookupVersions = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.put(process.env.REACT_APP_GATEWAY_URI,'iquoteapi/itemlookupversion/bulk', body);
    } catch (error) {
        console.error("Error updating item lookup versions:", error);
        return [];
    }
  }
};